
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'one-third column thumbnail thumbnail-hover-enabled--false medium-down--one-half' }, _createElement('div', { 'className': 'product-wrap' }, _createElement('div', { 'className': 'relative product_image' }, _createElement('a', { 'href': this.url }, _createElement('div', { 'className': 'image__container' }, _createElement('div', { 'className': 'image-element__wrap' }, _createElement('img', {
                    'src': this.imageOrDefault(this.image),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError,
                    'className': 'transition--blur-up lazyautosizes ls-is-cached lazyloaded'
                }))))), _createElement('div', { 'className': 'price-ui-badges price-ui-badges--square' }, this.on_sale ? _createElement('div', {
                    'className': 'price-ui-badge price-ui-badge--loading',
                    'key': '584'
                }, _createElement('div', { 'className': 'price-ui-badge__sticker price-ui-badge__sticker--sale' }, _createElement('span', { 'className': 'price-ui-badge__sticker-text' }, 'Sale'))) : null)), _createElement('a', {
                    'href': this.url,
                    'className': 'product-info__caption'
                }, _createElement('div', { 'className': 'product-details' }, _createElement('span', mergeProps({
                    'className': 'title',
                    'itemProp': 'name'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('span', { 'className': 'price' + (this.on_sale ? ' sale' : '') }, this.price_varies ? _createElement('span', {
                    'className': 'price-from',
                    'key': '1188'
                }, _translate(`price_from`)) : null, _createElement('span', { 'className': 'current_price' }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.price))), this.compare_at_price ? _createElement('span', {
                    'className': 'was_price',
                    'key': '1403'
                }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.compare_at_price))) : null))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []